// extracted by mini-css-extract-plugin
export var checkbox = "_9g-0";
export var circle = "_9g-3";
export var horizontalContainer = "_9g-7";
export var sm = "_9g-5";
export var switch0 = "_9g-2";
export var switchDisabled = "_9g-8";
export var switchEnabled = "_9g-1";
export var textSwitchContainer = "_9g-9";
export var textSwitchOption = "_9g-a";
export var textSwitchOptionSelected = "_9g-b";
export var verticalContainer = "_9g-6";
export var xs = "_9g-4";